/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("web/script/polyfills/fetch");
var classListPolyfill = require("web/script/polyfills/classList");

import _ from "underscore";
import environment from "web/script/modules/environment";
import googleConversion from "web/script/embedded/google-conversion";

export default {
    conversionIdSearch: 982977399,
    conversionLabel: "KvA6CL_g7pABEPeW3NQD",
    conversionIdsCSS: {
        "lyst.co.uk": 827715413,
        "lyst.de": 788956605,
        "lyst.fr": 804655814,
        "lyst.es": 801694380,
        "lyst.it": 783391789,
        "lyst.com": 778302557
    },

    init: function(analytics) {
        googleConversion("config", "AW-" + this.conversionIdSearch, { send_page_view: false });
        let domain = analytics._getCookieDomain();
        if (domain in this.conversionIdsCSS) {
            googleConversion("config", "AW-" + this.conversionIdsCSS[domain], {
                send_page_view: false
            });
        }
    },

    send: function(data) {
        // this will contain any promises we generate
        var promises = [];

        _.each(data, event => {
            if (event.type === "page_view") {
                let adwordsPayload = {
                    google_remarketing_only: true
                };
                if (event.data.product_id) {
                    adwordsPayload.ecomm_prodid = event.data.product_id;
                    adwordsPayload.ecomm_pagetype = "product";
                }
                if (event.data.paid_no_retarget) {
                    adwordsPayload.no_retarget = event.data.paid_no_retarget;
                }
                if (event.data.life_cycle_stage) {
                    adwordsPayload.life_cycle_stage = event.data.life_cycle_stage;
                }
                // Send to default group - all accounts
                googleConversion("event", "page_view", adwordsPayload);
            } else if (
                event.type === "event" &&
                event.data.category === "affiliate" &&
                (event.data.action === "lead" || event.data.action === "lead_sold_out")
            ) {
                // Remarketing pixel, send to default group - all accounts
                promises.push(createGtagPromise("page_view", { value: 0 }));
                // Conversion pixel, send to search account only
                promises.push(
                    createGtagPromise("conversion", {
                        send_to: "AW-" + this.conversionIdSearch + "/" + this.conversionLabel,
                        currency: "USD",
                        value: environment.get("averageNetCommission"),
                        label: this.conversionLabel
                    })
                );
            }
        });

        // wait for any promises what we were asked to wait for
        return Promise.all(promises);
    }
};

function createGtagPromise(event, data) {
    return new Promise(resolve => {
        // create gtag
        data.event_callback = resolve;
        googleConversion("event", event, data);
    });
}

